import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import Logo from 'public/logo.svg';
import { Card, Express, P } from './DeliveryService.styled';
type Props = {};
export default function DeliveryServiceCard({}: Props) {
  const { t: tProduct } = useTranslation('InnerProduct');
  return (
    <Card>
      <Image src={Logo} width={142.96} height={20.03} alt="logo" />
      <Express>Express</Express>
      <P>Now you can Enjoy Same Day Delivery Service Now you can Enjoy Same Day Delivery Service</P>
    </Card>
  );
}
